module.exports = __webpack_public_path__ + "img/30.6ad360ba.jpg";